<template lang="html">
  <div>
    <!-- grey darken-4 -->
    <v-footer height="auto" inset class="footer-padding footer-gradient">
      <v-layout justify-center column mx-3 my-3>
        <v-layout justify-center wrap row>
          <v-btn v-for="link in links" :key="link" :to="link === 'Careers' ? '/working-at-blitzoo' : link" color="white" flat round @click.stop="linkClicked(link)" class="footer-btn">
            <span class="footer-btn">{{ link }}</span>
          </v-btn>
        </v-layout>

        <v-layout justify-center>
          <v-flex color="#130038" text-xs-center white--text xs12 sm10 md8 lg6 xl4>
            <span class="footer-copyright">
              &copy;2019-{{ currentYear }} Blitzoo, Inc. &nbsp;All rights reserved. &nbsp;Some features may require in-app purchase. &nbsp;App Store is a service mark of Apple Inc. &nbsp;Android is a trademark of Google Inc. &nbsp;Google Play is a trademark of Google Inc. &nbsp;Facebook&copy; and its logo are trademarks of Facebook, Inc. &nbsp;All other trademarks or service marks used herein are either trademarks or registered trademarks of Blitzoo, Inc., its affiliates or its licensors. &nbsp;Artwork, descriptions, game play, photographs, videos, and other product details depicted herein are subject to change.
            </span>
            <!-- Copyright &copy; 2025 Blitzoo Games, Inc. &nbsp;All rights reserved. &nbsp;Some features may require in-app purchase. &nbsp;App Store is a service mark of Apple Inc. &nbsp;Android is a trademark of Google Inc. &nbsp;Google Play is a trademark of Google Inc. &nbsp;Facebook&reg; and its logo are trademarks of Facebook, Inc.<br> -->
          </v-flex>
        </v-layout>

        <v-flex color="#130038" text-xs-center white--text xs12 align-start>
          <v-btn color="white" flat to="terms" round class="footer-small-btn">
            <span class="footer-small-btn">Terms of Service</span>
          </v-btn>
          <v-btn color="white" flat to="privacy" round class="footer-small-btn">
            <span class="footer-small-btn">Privacy Policy</span>
          </v-btn>
          <v-btn color="white" flat to="responsiblegaming" round class="footer-small-btn">
            <span class="footer-small-btn">Responsible Gaming</span>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-footer>
  </div>
</template>

<script>
import Terms from '../footerContent/Terms.vue'
import Privacy from '../footerContent/Privacy.vue'
import Trademarks from '../footerContent/Trademarks.vue'
import Patents from '../footerContent/Patents.vue'
import { EventBus } from '../utils/eventBus'

export default {
  name: 'Footer',
  components: {
    Terms,
    Privacy,
    Trademarks,
    Patents
  },
  computed: {
    mobile () {
      return navigator.userAgent.toLowerCase().indexOf('iphone') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('android') > -1 ||
        navigator.userAgent.toLowerCase().indexOf('ipad') > -1
    },
    currentYear () {
      return new Date().getFullYear()
    }
  },
  data () {
    return {
      links: [
        'About',
        'Games',
        'Careers',
        'Contact'
        // 'Trademarks',
        // 'Patents'
      ],
      termsofuse: false,
      privacypolicy: false,
      trademarks: false,
      patents: false,
      icons: [
        // 'fab fa-facebook',
        // 'fab fa-twitter',
        // 'fab fa-google-plus',
        // 'fab fa-linkedin',
        // 'fab fa-instagram'
        require('../../assets/ConnectWithUs/Button_TwitterEnabled.png'),
        require('../../assets/ConnectWithUs/Button_FacebookEnabled.png'),
        require('../../assets/ConnectWithUs/Button_YoutubEnabled.png'),
        require('../../assets/ConnectWithUs/Button_LinkedInEnabled.png')
      ],
      hoverIcons: [
        require('../../assets/ConnectWithUs/Button_TwitterOver.png'),
        require('../../assets/ConnectWithUs/Button_FacebookOver.png'),
        require('../../assets/ConnectWithUs/Button_YoutubOver.png'),
        require('../../assets/ConnectWithUs/Button_LinkedInOver.png')
      ]
    }
  },
  methods: {
    socialLink (icon) {
      switch (icon) {
        case 0:
          window.open('http://link.showmevegasslots.com/ShowMeVegasSlots_Twitter', '_blank')
          break
        case 1:
          window.open('http://link.showmevegasslots.com/ShowMeVegasSlots_Facebook', '_blank')
          break
        case 2:
          window.open('http://link.showmevegasslots.com/ShowMeVegasSlots_YouTube', '_blank')
          break
        case 3:
          window.open('http://link.showmevegasslots.com/KingShowGames_LinkedIn', '_blank')
          break
      }
    },
    linkClicked (link) {
      let chosen = link.replace(/\s/g, '').toLowerCase()
      this[chosen] = true
    },
    changeImage (index) {
      let el = document.querySelector(`#footer-${index}`)
      el.src = this.hoverIcons[index]
      el.srcset = this.hoverIcons[index]
    },
    defaultImage (index) {
      let el = document.querySelector(`#footer-${index}`)
      el.src = this.icons[index]
      el.srcset = this.icons[index]
    }
  },
  mounted () {
    EventBus.$on('termsClicked', () => {
      this.termsofuse = false
    })

    EventBus.$on('privacyClicked', () => {
      this.privacypolicy = false
    })

    EventBus.$on('trademarksClicked', () => {
      this.trademarks = false
    })

    EventBus.$on('patentsClicked', () => {
      this.patents = false
    })
  }
}
</script>

<style lang="scss">
.footer-btn {
  font-family: 'open-sans-bold', serif;
  font-style: normal;
  font-weight: 300;
  color: #ffffff;
  font-size: 17px;
  text-transform: none !important; // to get rid of all uppercase effect
}

.footer-small-btn {
  font-family: 'open-sans-semibold', serif;
  color: #00ccff;
  font-size: 13px;
  text-transform: none !important; // to get rid of all uppercase effect
  margin: 0 0.5rem !important;
  padding: 0 !important;
}

.footer-copyright {
  font-family: 'open-sans-semibold', serif;
  color: #b000ff;
  font-size: 14px;
}

.footer-social {
  color: white;
  font-size: 1.5rem;
  display: flex;
  flex-direction: column;
  background-color: black;
  border-top-right-radius: 2rem;
  border-top-left-radius: 2rem;
}

.footer-padding {
  padding-bottom: 5rem;
}

.footer-gradient {
  background: rgb(18,0,53) !important;
  background: linear-gradient(rgba(18,0,53,1), rgba(25,0,79,1)) !important;
}

.center {
  justify-content: center;
}

.end {
  justify-content: flex-end;
}
</style>
